import { render } from "./addemployee.vue?vue&type=template&id=94627fd0"
import script from "./addemployee.vue?vue&type=script&lang=js"
export * from "./addemployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__